module.exports = __webpack_public_path__ + "img/game_style.e95413a9.webp";